import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

const MarkdownContent = ({ content, onLinkClick }) => {
  // Transform citation markers [^n] into clickable links before rendering
  const processedContent = content.replace(
    /\[\^(\d+)\]/g,
    '<sup><a href="#" class="citation-link">[$1]</a></sup>'
  );

  // Custom components for ReactMarkdown
  const components = {
    // Override the default link component
    // eslint-disable-next-line no-unused-vars
    a: ({ node, children, ...props }) => (
      <a
        {...props}
        onClick={(e) => {
          // Pass through the click event to parent handler
          onLinkClick(e);
        }}
      >
        {children}
      </a>
    ),
    // Override sup to prevent nesting issues
    // eslint-disable-next-line no-unused-vars
    sup: ({ node, children, ...props }) => <sup {...props}>{children}</sup>,
  };

  return (
    <ReactMarkdown rehypePlugins={[rehypeRaw]} components={components}>
      {processedContent}
    </ReactMarkdown>
  );
};

export default MarkdownContent;

MarkdownContent.propTypes = {
  content: PropTypes.string.isRequired,
  onLinkClick: PropTypes.func,
};
